import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useState,
} from "react";

const SearchContext = createContext<{
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
}>({
  searchTerm: "",
  setSearchTerm: () => undefined,
});

const SearchContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <SearchContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

const useSearch = () => useContext(SearchContext);

export { useSearch, SearchContextProvider };
